/** Single clipboard primitive shared across the inquiry draft composer. */
export function copyToClipboard(text: string): void {
  try {
    // writeText rejects asynchronously when access is denied (insecure context,
    // no user gesture) — swallow the rejection so it doesn't go unhandled.
    void navigator.clipboard?.writeText(text).catch(() => {})
  } catch {
    /* clipboard API unavailable — no-op */
  }
}
